import { Button, type ButtonProps, Icon } from '@inflearn/ds-react';
import { faArrowRight } from '@inflearn/pro-regular-svg-icons';

import { ACCOUNT_URL } from '../../../constants/urls';
import useCheckLoginSession from '../../../hooks/useCheckLoginSession';
import { useLoginModalContext } from '../../../providers/ControlLoginModalContextProvider';
import { eventNames } from '../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../utils/GTM/useTrackMixpanelEvent';
import type { JoinInstructorSpot } from './constants/gtmEventParams';

interface StartInstructorButtonProps extends ButtonProps {
  spot?: JoinInstructorSpot;
}

const StartInstructorButton = ({ spot, ...props }: StartInstructorButtonProps) => {
  const { isLoggedIn } = useCheckLoginSession();
  const { open: openLoginModal } = useLoginModalContext();
  const { trackMixpanelEvent } = useTrackMixpanelEvent();

  const handleClick = () => {
    if (spot) {
      trackMixpanelEvent(eventNames.CLICK_JOIN_INSTRUCTOR, { spot });
    }
  };

  if (isLoggedIn) {
    return (
      <Button
        component="a"
        href={ACCOUNT_URL.INSTRUCTOR_APPLICATION()}
        size="lg"
        radius="xl"
        rightIcon={<Icon icon={faArrowRight} size="lg" color="white" />}
        onClick={handleClick}
        {...props}
      />
    );
  }

  return (
    <Button
      onClick={() => {
        handleClick();
        openLoginModal();
      }}
      size="lg"
      radius="xl"
      rightIcon={<Icon icon={faArrowRight} size="lg" color="white" />}
      {...props}
    />
  );
};

export default StartInstructorButton;
